module.exports = __webpack_public_path__ + "img/frame (59).27870b9f.jpg";